import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ShopRedirectService } from '../../services/shop-redirect.service';

@Component({
  selector: 'app-shop-redirect',
  templateUrl: './shop-redirect.component.html',
  styleUrls: ['./shop-redirect.component.scss'],
  standalone: false,
})
export class ShopRedirectComponent implements OnInit {
  isCreatingRedirectToken: boolean;

  constructor(
    private router: Router,
    private shopRedirectService: ShopRedirectService,
  ) {}

  ngOnInit(): void {
    this.shopRedirectService.xchangeClicked(() => {
      this.router.navigateByUrl(`/secured/home`);
    });
  }
}
